const API_KEY = "196e8ac7ee5749f8b527f3c89df506ba";

const requests = {
    normal: `?apiKey=${API_KEY}`
}

export default requests;